import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalTypesComponent } from 'src/app/components/shared/modals-types/modal-types.component';
import { CommentDto } from 'src/app/models/maintenance/comment';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { HttpService, MessageService } from 'brainloper-ui';
import { UploadService } from './upload.service';
import { ModalFilesComponent } from 'src/app/components/shared/modal-files/modal-files.component';

@Injectable({
  providedIn: 'root',
})
export class CommentService {
  constructor(
    public dialog: MatDialog,
    private message: MessageService,
    private http: HttpService,
    private uploadService: UploadService
  ) {}

  async addComment(idWorkOrder: number, onSuccess?: () => void) {
    let size: number = screen.width > 500 ? 60 : 50;
    const dialogRef = this.dialog.open(ModalTypesComponent, {
      width: `${size}vh`,
      data: {
        name: 'comentario',
        body: new CommentDto(),
      },
    });

    dialogRef.afterClosed().subscribe(async (commentData: CommentDto) => {
      if (!commentData) return;      
      this.message.openLoading('Cargando', 'Registro de comentario');
      await this.handleAttachment(commentData);
      commentData.orderId = idWorkOrder;
      
      await this.http.postDataBody(
        EndpointDictionary.WorkOrder.COMMENTS.CRUD_DATA,
        commentData
      );
      this.message.closeLoading();
      if (onSuccess) onSuccess();
    });
  }

  editComment(comment: CommentDto, onSuccess?: () => void) {
    let size: number = screen.width > 500 ? 60 : 50;
    const dialogRef = this.dialog.open(ModalTypesComponent, {
      width: `${size}vh`,
      data: {
        name: 'comentario',
        body: comment,
      },
    });
    dialogRef.afterClosed().subscribe(async (commentData: CommentDto) => {
      if (!commentData) return;
      
      this.message.openLoading('Cargando', 'Actualizando comentario');
      await this.handleAttachment(commentData);   
      commentData.orderId = comment.orderId;
      commentData.id = comment.id;
      commentData.createdById = comment.createdById;
      let res = await this.http.putDataPromise(
        `${EndpointDictionary.WorkOrder.COMMENTS.CRUD_DATA}/${comment.id}`,
        commentData
      );
      if (!res['body']) {
        this.message.Error('Error!', `No se puede editar: ${res['message']}`);
      }
      this.message.closeLoading();
      if (onSuccess) onSuccess();
    });
  }

  showAttachment($event: string, companyId: number) {
    const lower = $event.toLowerCase();
    if (lower.match(/\.(pdf)$/)) {
      let attachedFile = `${EndpointDictionary.Base._BASE_URL_V2}${$event}/${companyId}`;
      let ancho: number = 800;
      let alto: number = 700;
      var x: number = screen.width / 2 - ancho / 2;
      var y: number = screen.height / 2 - alto / 2;
      window.open(
        attachedFile,
        'popup',
        `width=${ancho}, height=${alto}, left=${x}, top=${y}`
      );
      return;
    }

    if (
      lower.match(/\.(doc|docx)$/) ||
      lower.includes(
        '.vnd.openxmlformats-officedocument.wordprocessingml.document'
      )
    ) {
      let attachedFile = `${EndpointDictionary.Base._BASE_URL_V2}${$event}/${companyId}`;
      let baseName = $event.split('/').pop() || 'archivo';
      if (!baseName.endsWith('.doc') && !baseName.endsWith('.docx')) {
        baseName = baseName.split('.')[0] + '.docx';
      }
      fetch(attachedFile)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = baseName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        });
      return;
    }
    this.dialog.open(ModalFilesComponent, {
      data: $event,
    });
  }

  private cleanAttachmentText(comment: string): string {
    return comment ? comment.replace(/ Archivo adjunto: \[.*?\]/g, '') : '';
  }

  private async handleAttachment(commentData: CommentDto): Promise<void> {
    commentData.comment = this.cleanAttachmentText(commentData.comment);
    if (commentData.file) {
      const file = await this.uploadService.uploadFile(commentData.file);
      commentData.attachmentUrl = file;
      commentData.comment = `${commentData.comment} Archivo adjunto: [${commentData.file.name}]`;
    } else {
      commentData.attachmentUrl = null;
    }
    delete commentData?.file;
  }
}
